import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Editor } from '@hugerte/hugerte-react';

interface NewMailPageProps {
  accessToken?: string;
  onSuccess?: () => void;
  onCancel?: () => void;
}

const NewMailPage: React.FC<NewMailPageProps> = ({ accessToken, onSuccess, onCancel }) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('subject', subject);
    formData.append('body', body);
    if (file) {
      formData.append('file', file);
    }
    try {
      const res = await fetch('/api/email', {
        method: 'POST',
        headers: accessToken ? { 'Authorization': `Bearer ${accessToken}` } : undefined,
        body: formData,
      });
      if (res.ok) {
        alert('Mail created successfully.');
        if (onSuccess) onSuccess();
        else navigate('/mail');
      } else {
        const data = await res.json();
        alert('Failed to create mail: ' + (data.error || 'Unknown error'));
      }
    } catch (err) {
      alert('Error creating mail: ' + err);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Mail</h1>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block font-semibold mb-2">Subject</label>
          <input
            type="text"
            className="w-full border px-3 py-2 rounded"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-2">Body</label>
          <Editor
            value={body}
            onEditorChange={setBody}
            init={{ height: 300 }}
          />
        </div>
        <div>
          <label className="block font-semibold mb-2">Attachment (PDF)</label>
          <input type="file" accept="application/pdf" onChange={handleFileChange} />
          {file && <div className="mt-2 text-sm">Selected: {file.name}</div>}
        </div>
        <div className="flex gap-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Create Mail
          </button>
          {onCancel && (
            <button
              type="button"
              className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
              onClick={onCancel}
            >
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default NewMailPage;
